<template>
  <v-card flat>
    <v-alert
      v-if="alertMsg.status"
      :timeout="alertMsg.timeout"
      :color="alertMsg.color"
      :type="alertMsg.type"
      dismissible
    >
      {{ alertMsg.text }}
    </v-alert>
    <v-card-text>
      <v-form v-model="valid" ref="busApplicant">
        <v-row>
          <v-col cols="12" md="6" sm="12" class="pt-0">
            <label class="ma-0 pa-0"
              >{{ $t("fullName") }}<span style="color: #f00">*</span></label
            >
            <v-text-field
              v-model="editedItem.full_name"
              :rules="validations.firstnameValidations"
              dense
              :placeholder="$t('fullName')"
              outlined
              required
            ></v-text-field>
          </v-col>
          <v-col cols="12" md="6" sm="12" class="pt-0">
            <label class="ma-0 pa-0">{{ $t("Gender") }}</label>
            <v-autocomplete
              :placeholder="$t('gender_placeholder')"
              :items="genderOptions"
              v-model="editedItem.gender"
              dense
              outlined
            ></v-autocomplete>
          </v-col>

          <v-col cols="12" md="6" sm="12" class="pt-0">
            <label class="ma-0 pa-0">{{ $t("date_of_birth_business") }}</label>

            <v-menu
              ref="dobmenu"
              v-model="dobmenu"
              :close-on-content-click="false"
              lazy
              transition="scale-transition"
              :offset-x="true"
              full-width
              min-width="290px"
            >
              <template v-slot:activator="{ on }">
                <v-text-field
                  v-model="editedItem.dob"
                  persistent-hint
                  clearable
                  v-on="on"
                  type="date"
                  dense
                  @change="ValidateAge"
                  :min="minDate"
                  :max="maxDate"
                  outlined
                >
                </v-text-field>
              </template>
            </v-menu>
          </v-col>

          <v-col cols="12" md="6" sm="12" class="pt-0">
            <label class="ma-0 pa-0">{{
              $t("country_of_birth_business")
            }}</label>
            <v-autocomplete
              v-model="editedItem.country_code"
              :placeholder="$t('country_of_birth_placeholder')"
              :items="country_options"
              item-text="name"
              item-value="id"
              outlined
              required
              dense
            ></v-autocomplete>
          </v-col>

          <v-col cols="12" md="6" sm="12" class="pt-0">
            <label class="ma-0 pa-0"
              >{{ $t("Nationality") }}<span style="color: #f00">*</span></label
            >
            <v-autocomplete
              :placeholder="$t('nationality_placeholder')"
              dense
              v-model="editedItem.nationality_code"
              :items="nationality_options"
              :rules="validations.nationalityValidations"
              item-text="name"
              item-value="id"
              outlined
            ></v-autocomplete>
          </v-col>

          <v-col cols="12" md="6" sm="12" class="pt-0">
            <label class="ma-0 pa-0"
              >{{ $t("Occupation") }}<span style="color: #f00">*</span></label
            >
            <v-autocomplete
              v-model="editedItem.occupation_code"
              :items="occupation_options"
              item-text="name"
              item-value="id"
              :rules="validations.OcupationValidations"
              :placeholder="$t('occupation_placeholder')"
              dense
              outlined
              required
            ></v-autocomplete>
          </v-col>
          <v-col cols="12" md="6" sm="12" class="pt-0">
            <label class="ma-0 pa-0">{{ $t("mobile_number") }}</label>
            <vue-phone-number-input
              v-digits-only
              default-country-code="MY"
              @update="onChangeNumber"
              :error="mobileNumberError"
              v-model="editedItem.phone_number"
            />
            <span
              v-if="mobileNumberError"
              style="color: #ff5252; font-size: 12px"
            >
              {{ $t("invalid_phone_number") }}
            </span>
          </v-col>
          <v-col
            cols="12"
            md="6"
            v-if="validationFields.includes('No of Shares')"
          >
            <label class="ma-0 pa-0"
              >{{ $t("share_holder_percentage")
              }}<span style="color: #f00">*</span></label
            >
            <v-text-field
              :placeholder="$t('share_holder_percentage')"
              v-model="editedItem.no_of_shares"
              suffix="%"
              type="number"
              :rules="validations.sharesRules"
              outlined
              required
              hide-spin-buttons
              dense
            ></v-text-field>
          </v-col>
          <v-col cols="12" md="6" sm="12" class="pt-0">
            <label class="ma-0 pa-0"
              >{{ $t("idType") }}<span style="color: #f00">*</span></label
            >
            <v-select
              v-model="editedItem.id_type_code"
              :menu-props="{ bottom: true, offsetY: true }"
              :rules="validations.id_proofrules"
              :items="idtypes_val"
              item-text="name"
              item-value="id"
              outlined
              required
              :placeholder="$t('idtype_select_placeholder')"
              dense
            ></v-select>
          </v-col>

          <v-col v-if="!isMykad" cols="12" md="6">
            <label class="ma-0 pa-0"
              >{{ $t("isuueDate") }}<span style="color: #f00">*</span></label
            >
            <v-text-field
              v-model="editedItem.id_issue_date"
              :rules="validations.issuedaterules"
              dense
              required
              outlined
              type="date"
              :max="currentDate"
            />
          </v-col>
          <v-col cols="12" md="6" sm="12" class="pt-0">
            <label class="ma-0 pa-0"
              >{{ $t("Location")
              }}<span
                v-if="isPassportType(editedItem.id_type_code)"
                style="color: #f00"
                >*</span
              ></label
            >
            <v-autocomplete
              v-model="editedItem.id_issue_country"
              item-text="name"
              item-value="id"
              :items="country_options"
              :rules="validations.issue_locationRules"
              :placeholder="$t('Location')"
              dense
              outlined
              required
              :disabled="disableIssueLoc"
              :min="currentDate"
            />
          </v-col>

          <v-col v-if="!isMykad" cols="12" md="6">
            <label class="ma-0 pa-0"
              >{{ $t("expiryDate") }}<span style="color: #f00">*</span></label
            >
            <v-text-field
              v-model="editedItem.id_expiry_date"
              :rules="validations.expDateRules"
              dense
              outlined
              required
              type="date"
              :min="currentDate"
            />
          </v-col>

          <v-col cols="12" md="6" sm="12" class="pt-0">
            <label class="ma-0 pa-0"
              >{{ $t("idNumber") }}<span style="color: #f00">*</span></label
            >
            <v-text-field
              v-model="editedItem.id_number"
              :rules="validations.id_numberRules"
              :placeholder="$t('id_number_placeholder')"
              outlined
              required
              dense
            ></v-text-field>
          </v-col>

          <v-col cols="12" md="6" sm="12" class="pt-0">
            <label class="ma-0 pa-0"
              >{{ $t("IDFirstPage") }}<span style="color: #f00">*</span></label
            >
            <v-file-input
              v-model="editedItem.ID_First_Page"
              :rules="validations.firstpage_rules"
              dense
              accept="image/png, image/jpeg, image/bmp"
              :placeholder="$t('idtype_first_page_placeholder')"
              outlined
              ref="idfirstfile"
              required
              prepend-icon=""
              @change="
                genrateURL(
                  'frontPageUrl',
                  editedItem.ID_First_Page,
                  'ID_First_Page'
                )
              "
            >
              <template v-slot:append>
                <v-icon
                  aria-hidden="false"
                  class="color-primary"
                  @click="openIdfirst"
                >
                  mdi-cloud-upload
                </v-icon>
              </template>

              <template v-slot:append-outer>
                <v-img
                  v-if="frontPageUrl"
                  class="ml-1"
                  max-height="40"
                  max-width="50"
                  :src="frontPageUrl"
                  @click="handleImageViewer(frontPageUrl)"
                />
              </template>
            </v-file-input>
          </v-col>

          <v-col cols="12" md="6" sm="12" class="pt-0">
            <label class="ma-0 pa-0">{{ $t("IDLastPage") }}</label>
            <v-file-input
              v-model="editedItem.ID_Last_Page"
              dense
              accept="image/png, image/jpeg, image/bmp"
              :placeholder="$t('idtype_last_page_placeholder')"
              outlined
              ref="idlastfile"
              required
              prepend-icon=""
              @change="
                genrateURL(
                  'backPageUrl',
                  editedItem.ID_Last_Page,
                  'ID_Last_Page'
                )
              "
            >
              <template v-slot:append>
                <v-icon
                  aria-hidden="false"
                  class="color-primary"
                  @click="openIdlast"
                >
                  mdi-cloud-upload
                </v-icon>
              </template>

              <template v-slot:append-outer>
                <v-img
                  v-if="backPageUrl"
                  class="ml-1"
                  max-height="40"
                  max-width="50"
                  :src="backPageUrl"
                  @click="handleImageViewer(backPageUrl)"
                />
              </template>
            </v-file-input>
          </v-col>
        </v-row>
      </v-form>
    </v-card-text>
    <v-card-actions>
      <v-spacer></v-spacer>

      <v-btn
        color="primary"
        :disabled="isSubmitting"
        :loading="isSubmitting"
        @click="editedItem.biz_user_id ? update() : onClickNext()"
        >{{ editedItem.biz_user_id ? "Update" : "Save" }}</v-btn
      >
    </v-card-actions>
    <image-viewer
      :showDialog="isImageViewer"
      :picture="{
        PicHeight: '435',
        PicWidth: 600,
        Pic: imageViewerUrl,
      }"
      @closeImageViewer="handleCloseImageViewer"
    ></image-viewer>
  </v-card>
</template>
<script>
import { mapGetters } from "vuex";
import { i18n as $ } from "../../locale/index";
import VuePhoneNumberInput from "vue-phone-number-input";
import { parsePhoneNumberFromString } from "libphonenumber-js";
import "vue-phone-number-input/dist/vue-phone-number-input.css";
import { findDatePrevious } from "../../utils/helper";
import { BusUserTypes } from "../../utils/BusDocuments";
import validatemixin from "@/mixins/Busvalidate.mixin";
import imageViewer from "../tools/imageViewer.vue";
import handleImageUpload from "../../mixins/compressImage.mixin";
import commonService from "@/services/AgentCommonService/commonService.js";
import AgentService from "@/services/agentService/AgentService";
import alerts from "@/mixins/alerts";
import digitsOnly from "@/directives/digitsOnly";
export default {
  mixins: [validatemixin, handleImageUpload, alerts],
  directives: { digitsOnly },
  data: () => ({
    id_type: "",
    dialog: false,
    valid: true,
    currentDate: new Date().toJSON().split("T")[0],
    buscheckboxes: BusUserTypes(),
    Entitycheckbox: [],
    validationFields: [],
    backPageUrl: null,
    frontPageUrl: null,
    dialogDelete: false,
    dobmenu: false,
    kycStatus: null,
    disableBystatus: null,
    disableIssueLoc: false,
    id_type_back: null,
    issue_location: null,
    maxDate: "",
    minDate: "",
    isDobError: false,
    expriydate: false,
    phoneCountryCode: "MY",
    isLoading: false,
    loader: false,
    country_options: [],
    relation_options: [],
    idtypes: [],
    idtypes_val: [],
    idtype_objs: [],
    nationality_options: [],
    occupation_options: [],
    occupation_objs: [],
    genderOptions: [
      { text: "Male", value: "M" },
      { text: "Female", value: "F" },
    ],
    isSubmitted: false,
    isUploading: false,
    isSubmitting: false,
    alertMsg: {
      status: false,
      text: "",
      timeout: 2000,
      color: "blue-grey",
      type: "info",
    },
    countrySelected: {},
    headers: [
      {
        text: "Full Name",
        align: "start",
        sortable: false,
        value: "full_name",
      },
      { text: "Type", value: "type" },
      { text: "Email", value: "email_id" },
      { text: "ID type", value: "id_type_code" },
      { text: "ID number", value: "id_number" },
      { text: "First page", value: "first_page" },
      { text: "Last page", value: "last_page" },
      { text: "Actions", value: "actions" },
    ],
    getinformation: [],
    editedIndex: -1,
    biz_user_id: "",
    imageViewerUrl: "",
    isImageViewer: false,
    userId: null,
    editedItem: {
      applicant_type: "Representative",
      full_name: "",
      middle_name: "",
      last_name: "",
      gender: "",
      dob: null,
      email_id: "",
      phone_number: "",
      nationality_code: "",
      occupation_code: "",
      country_code: "",
      // applicant_country_code: "",
      id_type_code: null,
      id_number: null,
      ID_First_Page: null,
      ID_Last_Page: null,
      no_of_shares: null,
      id_issue_date: null,
      id_expiry_date: null,
      id_issue_country: "",
      biz_user_id: null,
    },
    deleteId: "",

    validations: {
      emailValidations: [
        (v) => !!v || $.t("emailMsg1"),
        (v) =>
          /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(v) ||
          $.t("emailMsg2"),
      ],
      firstnameValidations: [
        (v) => !!v || $.t("fullname_required"),
        (v) => /^([a-zA-Z]+\s?)*$/.test(v) || $.t("invalid_fullname"),
      ],
      nationalityValidations: [(v) => !!v || $.t("nationalityMsg1")],
      OcupationValidations: [(v) => !!v || "Occupation is required"],
      selfy_rules: [(v) => !!v || $.t("file_select_placeholder")],
      firstpage_rules: [(v) => !!v || $.t("file_select_placeholder")],
      issuedaterules: [
        (v) => !!v || $.t("issueDateMsg1"),
        (v) => !v || v <= new Date().toJSON().split("T")[0] || $.t("issue_date_valid"),
      ],
      issue_locationRules: [],
      expDateRules: [
        (v) => !!v || $.t("expiryDateMsg1"),
        (v) => !v || v > new Date().toJSON().split("T")[0] || $.t("expiry_date_issue_validate"),
      ],
      id_proofrules: [(v) => !!v || $.t("idtypeMsg1")],
      id_numberRules: [(v) => !!v || $.t("idnumberMsg1")],
      interviewData: [(v) => !!v || $.t("interviewDate")],
      interviewTime: [(v) => !!v || $.t("interviewTime")],
    },
  }),
  name: "BasicDetails",
  components: {
    VuePhoneNumberInput,
    imageViewer,
  },
  props: {
    isActive: {
      type: Boolean,
      default: true,
    },
    selctedEntity: {
      type: String,
    },
  },
  computed: {
    isValidNumber() {
      const value = String(this.editedItem.phone_number || "");
      if (!value) return false;
      const phone = parsePhoneNumberFromString(value, {
        defaultCountry: this.phoneCountryCode,
        extract: false,
      });
      return Boolean(phone && phone.isValid());
    },
    mobileNumberError() {
      return Boolean(this.editedItem.phone_number) && !this.isValidNumber;
    },
    isMykad() {
      return this.isMykadType(this.editedItem.id_type_code);
    },
    ...mapGetters("Transactional", [
      "realtion_list",
      "nationality_list",
      "occupation_list",
    ]),
    ...mapGetters("Authentication", ["country_list"]),
  },

  watch: {
    isActive(active) {
      if (active) this.getapplicant();
    },
    isMykad: "clearMykadDates",
    "editedItem.id_issue_date": "clearMykadDates",
    "editedItem.id_expiry_date": "clearMykadDates",
    "editedItem.applicant_type"(applicant_type) {
      console.log("applicant_type", applicant_type);
      this.validationFields = [...this.getRequired(applicant_type)];
      console.log("applicant_type:", this.getRequired(applicant_type));
    },

    "editedItem.id_type"(val) {
      this.idtype_objs.map((i) => {
        if (val === i.parameter_value) {
          this.id_type_code = i.parameter_code;
        }
      });
    },
    "editedItem.id_type_code"(val) {
      this.handleIdTypeChange(val);
    },

    id_type(val) {
      let selectedIdTypeCode = "";
      this.idtype_objs.map((i) => {
        if (val === i.value) {
          this.id_type_code = i.id;
          selectedIdTypeCode = i.value_code;
        }
      });
      this.handleIdTypeChange(selectedIdTypeCode);
    },

    "editedItem.issue_location"(val) {
      this.country_objs.map((i) => {
        if (val === i.name) {
          this.issue_location_code = i.iso3;
        }
      });
    },

    countrySelected(newVal) {
      console.log("Selected country", newVal);
      if (Object.keys(newVal).length > 0) {
        this.editedItem.country_code = newVal.name;
        this.editedItem.applicant_country_code = newVal.iso3;
      }
    },
  },

  mounted() {
    this.getOccupation();
    this.getNationalityList();
    this.getidtypes();
    this.getapplicant();
    this.maxDate = findDatePrevious(new Date(), 18);
    this.minDate = findDatePrevious(new Date(), 70);
  },

  methods: {
    clearMykadDates() {
      if (this.isMykad) {
        this.editedItem.id_issue_date = null;
        this.editedItem.id_expiry_date = null;
      }
    },
    isMykadType(idTypeCode) {
      return ["1", "MYKAD"].includes(String(idTypeCode).toUpperCase());
    },
    isMyprType(idTypeCode) {
      return ["2", "MYPR"].includes(String(idTypeCode).toUpperCase());
    },
    isMalaysiaIdentityType(idTypeCode) {
      return this.isMykadType(idTypeCode) || this.isMyprType(idTypeCode);
    },
    isPassportType(idTypeCode) {
      return ["4", "PASSPORT"].includes(String(idTypeCode).toUpperCase());
    },
    getCountryCode(country) {
      if (!country) return "";
      return country.iso_alpha3 || country.iso3 || country.id || country;
    },
    getDropdownCode(value) {
      if (!value) return "";
      return value.value_code || value.id || value;
    },
    handleIdTypeChange(idTypeCode) {
      this.clearMykadDates();
      this.disableIssueLoc = this.isMalaysiaIdentityType(idTypeCode);
      if (this.disableIssueLoc) this.editedItem.id_issue_country = "MYS";
      this.validations.issue_locationRules = this.isPassportType(idTypeCode)
        ? [(v) => !!v || $.t("issue_location_placeholder")]
        : [];
    },
    genrateURL(keyField, value, assignKey) {
      if (!keyField) return;

      if (!value) {
        if (assignKey == "ID_First_Page") {
          this.frontPageUrl = null;
        } else if (assignKey === "ID_Last_Page") {
          this.backPageUrl = null;
        }
        this.editedItem[`${assignKey}`] = null;
      } else {
        if (assignKey == "ID_First_Page") {
          this.frontPageUrl = URL.createObjectURL(value);
        } else if (assignKey === "ID_Last_Page") {
          this.backPageUrl = URL.createObjectURL(value);
        }
        this.editedItem[`${assignKey}`] = value;
      }
    },
    handleCloseImageViewer() {
      this.isImageViewer = !this.isImageViewer;
      this.imageViewerUrl = "";
    },
    handleImageViewer(url) {
      this.isImageViewer = !this.isImageViewer;
      this.imageViewerUrl = url;
    },

    async getapplicant() {
      if (!this.$route.query.login_id || !this.$route.query.customer_id || !this.isActive) return;
      this.isLoading = true;
      try {
        const response = await AgentService.getApplicantInfo({
          login_id: this.$route.query.login_id,
          customer_id: this.$route.query.customer_id,
        });
        if (response && response.data.status_code == 200) {
          if (response.data.data[0]) {
            const applicant_data = response.data.data[0];
            this.editedItem = {
              applicant_type: "Representative",
              full_name: applicant_data.full_name || "",
              middle_name: "",
              last_name: "",
              gender: applicant_data.gender || "",
              dob: applicant_data.dob || null,
              email_id: applicant_data.email_id || "",
              phone_number: applicant_data.phone_number || "",
              nationality_code: this.getCountryCode(applicant_data.nationality),
              occupation_code: this.getDropdownCode(applicant_data.occupation),
              country_code: this.getCountryCode(applicant_data.country),
              id_type_code: this.getDropdownCode(applicant_data.id_type),
              id_number: applicant_data.id_number || "",
              ID_First_Page: applicant_data.id_first_page
                ? {
                    name: applicant_data.id_first_page?.split("/").pop(),
                    value: applicant_data.id_first_page,
                  }
                : null,
              ID_Last_Page: applicant_data.id_last_page
                ? {
                    name: applicant_data.id_last_page?.split("/").pop(),
                    value: applicant_data.id_last_page,
                  }
                : null,
              no_of_shares: null,
              id_issue_date: applicant_data.id_issue_date || null,
              id_expiry_date: applicant_data.id_expiry_date || null,
              id_issue_country: this.getCountryCode(applicant_data.id_issue_country),
              biz_user_id: applicant_data.biz_user_id || null,
            };
            this.handleIdTypeChange(this.editedItem.id_type_code);
            this.backPageUrl = applicant_data.id_last_page
              ? applicant_data.id_last_page
              : null;
            this.frontPageUrl = applicant_data.id_first_page
              ? applicant_data.id_first_page
              : null;
          }
        } else {
          this.showAlertError(response.data.message);
        }
      } catch (error) {
        this.showAlertError(
          "Error: Something went wrong please try again later."
        );
        console.warn("Error", error);
      } finally {
        this.isLoading = false;
      }
    },

    async getOccupation() {
      try {
        const responseData = await commonService.getparameterdropdowns("OCC", "IND");
        if (responseData.data.status_code === 200) {
          this.occupation_options = responseData.data.data.map((i) => {
            this.occupation_objs.push(i);
            return {
              name: i.value,
              id: i.value_code,
            };
          });
        }

        console.log("Funds", responseData);
      } catch (e) {
        console.error(e);
      }
    },
    async fileUpload(fileObject, biz_user_id, doc_type) {
      if (!(fileObject instanceof Blob)) return;
      if (!biz_user_id) {
        throw new Error("Document upload failed: applicant id is missing");
      }
      const compressedFile = await this.handleImageUpload(fileObject);
      if (!(compressedFile instanceof Blob)) {
        throw new Error("Document could not be prepared for upload");
      }
      const fileData = new FormData();
      fileData.append("document", compressedFile);
      const response = await AgentService.UploadApplicantFiles(fileData, {
        login_id: this.$route.query.login_id,
        customer_id: this.$route.query.customer_id,
        biz_user_id,
        doc_type,
      });
      if (!response || response.data.status_code != 200) {
        throw new Error(response?.data?.message || "Document upload failed");
      }
    },
    async getidtypes() {
      try {
        const responseData = await commonService.getparameterdropdowns("DOC", "IND");
        if (responseData.data.status_code === 200) {
          responseData.data.data.map((idtype) => {
            this.idtypes.push(idtype.value);
            this.idtypes_val.push({
              name: idtype.value,
              id: idtype.value_code,
            });
            this.idtype_objs.push(idtype);
          });
        }

        console.log("Funds", responseData);
      } catch (e) {
        console.error(e);
      }
    },

    open() {
      this.$refs.selfiefile.$el.querySelector("input").click();
    },
    openIdlast() {
      this.$refs.idlastfile.$el.querySelector("input").click();
    },
    openIdfirst() {
      this.$refs.idfirstfile.$el.querySelector("input").click();
    },
    ValidateAge(value) {
      if (!value) this.isDobError = false;
      else this.isDobError = !(value <= this.maxDate && value >= this.minDate);
    },
    onChangeNumber(e) {
      if (e?.countryCode) this.phoneCountryCode = e.countryCode;
    },
    validateMobileNumber() {
      return !this.mobileNumberError;
    },
    getBizUserIdFromResponse(response) {
      return response?.data?.data?.[0]?.biz_user_id ||
        response?.data?.biz_user_id || this.editedItem.biz_user_id || this.userId;
    },
    async uploadApplicantDocuments(bizUserId) {
      await this.fileUpload(this.editedItem.ID_First_Page, bizUserId, "ID_First_Page");
      await this.fileUpload(this.editedItem.ID_Last_Page, bizUserId, "ID_Last_Page");
    },
    getApplicantPayload() {
      this.clearMykadDates();
      // Use the same country/nationality mapping as the customer portal.
      return {
        ...this.editedItem,
        country_code: this.editedItem.nationality_code,
        nationality_code: this.editedItem.country_code,
      };
    },

    async getNationalityList() {
      try {
        const responseData = await commonService.getCountryBirthList();
        if (responseData.data.status_code === 200) {
          responseData.data.data.map((i) => {
            this.country_options.push({
              name: i.country_name,
              id: i.iso_alpha3,
            });
            this.nationality_options.push({
              name: i.nationality,
              id: i.iso_alpha3,
            });
          });
        }

        console.log("countrys", responseData);
      } catch (e) {
        console.error(e);
      }
    },

    editItem(item) {
      this.editedIndex = this.getinformation.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.editedItem.applicant_type = item.type;
      console.log("image data", item.type);
      this.idtype_objs.map((ele) => {
        console.log("ele", ele);
        if (ele.value == item.id_type_code) {
          this.editedItem.id_type_code = ele.value_code;
        }
      });
      this.editedItem.ID_First_Page = item.first_page
        ? {
            name: item.first_page?.split("/").pop(),
            value: item.first_page,
          }
        : null;

      this.editedItem.ID_Last_Page = item.last_page
        ? {
            name: item.last_page?.split("/").pop(),
            value: item.last_page,
          }
        : null;
      this.backPageUrl = item.last_page ? item.last_page : null;
      this.frontPageUrl = item.first_page ? item.first_page : null;
      this.editedItem.occupation_code = item.occupation_code
        ? item.occupation_code
        : null;
      // this.getapplicant();
      this.dialog = true;
    },

    onClickNext() {
      if (this.isSubmitting) return;
      if (this.$refs.busApplicant.validate() && this.validateMobileNumber()) {
        return this.save();
      }
    },

    onClickBack() {
      this.$emit("onClickBack");
    },

    async save() {
      if (this.isSubmitting || !this.validateMobileNumber()) return;
      this.isSubmitting = true;
      this.loader = true;
      if (this.editedIndex > -1) {
        Object.assign(this.getinformation[this.editedIndex], this.editedItem);
      }
      try {
        const responseData = await AgentService.addApplicantInfo(
          this.getApplicantPayload(),
          {
            login_id: this.$route.query.login_id,
            customer_id: this.$route.query.customer_id,
          }
        );

        if (
          responseData &&
          responseData.data &&
          responseData.data.success === true
        ) {
          const bizUserId = this.getBizUserIdFromResponse(responseData);
          this.userId = bizUserId;
          this.editedItem.biz_user_id = bizUserId;
          await this.uploadApplicantDocuments(bizUserId);
          await this.getapplicant();
          this.showAlertSuccess(responseData.data.message);
        } else {
          this.showAlertError(`Creation Failed: ${responseData.data.message}`);
        }
      } catch (error) {
        this.showAlertError(
          error?.message || "Error: Something went wrong please try again later."
        );
      } finally {
        this.isSubmitting = false;
        this.loader = false;
      }
    },

    update() {
      if (this.isSubmitting) return;
      if (this.$refs.busApplicant.validate() && this.validateMobileNumber()) {
        return this.updateData();
      }
    },

    async updateData() {
      if (this.isSubmitting || !this.validateMobileNumber()) return;
      this.isSubmitting = true;
      this.loader = true;
      try {
        const responseData = await AgentService.updateApplicantInfo(
          this.getApplicantPayload(),
          {
            login_id: this.$route.query.login_id,
            customer_id: this.$route.query.customer_id,
            biz_user_id: this.editedItem.biz_user_id,
          }
        );
        if (responseData && responseData.data.status_code == 200) {
          const bizUserId = this.getBizUserIdFromResponse(responseData);
          this.userId = bizUserId;
          this.editedItem.biz_user_id = bizUserId;
          await this.uploadApplicantDocuments(bizUserId);
          await this.getapplicant();
          this.showAlertSuccess(responseData.data.message);
        } else {
          this.showAlertError(responseData.data.message);
        }
      } catch (error) {
        this.showAlertError(
          error?.message || "Error: Something went wrong please try again later."
        );
        console.warn("Error", error);
      } finally {
        this.isSubmitting = false;
        this.loader = false;
      }
    },
  },
};
</script>
<style>
.v-input .v-label {
  margin-bottom: 0px !important;
}
</style>
